<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
        <div slot="modal-title">
            Cronograma Desembolso SEBRAE -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="4">
                <b-form-group>
                    <label class="required">Parcela</label>
                    <b-input-group>
                        <b-form-input
                            type="number"
                            v-model="parcela"
                        ></b-form-input>
                        <b-form-invalid-feedback>A parcela é obrigatória</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4" md="4">
                <b-form-group>
                    <label class="required">Valor</label>
                    <b-input-group>
                        <money
                            v-model="valor"
                            v-bind="money"
                            @input="$v.valor.$touch()"
                            :state="$v.valor.$error ? false : null"
                            class="form-control text-right">
                        </money>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4" md="4">
                <b-form-group>
                    <label>Mês</label>
                    <b-input-group>
                        <date-picker
                            v-model="mes"
                            :config="$monthPickerOptions"
                            v-mask="'##/####'"
                        ></date-picker>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Descritivo</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="descritivo"
                        ></b-form-input>
                        <b-form-invalid-feedback>O campo Descritivo é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>

import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        pleito: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        },
        dataServicos: {
            type: Object
        },
    },

    validations() {
         return {
            parcela: {
                required: (value) => value !== null && value !== '' && value !== undefined
            },
            valor: {
                required: (value) => value !== null && value !== '' && value !== undefined
            },
            descritivo: {
                required: (value) => value !== null && value !== '' && value !== undefined
            }
         }
    },

    data() {
        return {
            parcela: '',
            mes: '',
            valor: '',
            descritivo: '',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },
    methods: {
        preencher() {
            if (this.operacaoProp == 'A') {
                this.parcela = this.cronogramaDesembolsoSebrae?.parcela || ''
                this.mes = this.cronogramaDesembolsoSebrae?.mes || ''
                this.valor = this.cronogramaDesembolsoSebrae?.valor || ''
                this.descritivo = this.cronogramaDesembolsoSebrae?.descritivo || ''
            }
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar(){
            this.parcela = ''
            this.mes = ''
            this.valor = ''
            this.descritivo = ''
        },

        salvar() {
            let cronogramaDesembolsoSebraeDto = {
                pleitoId : this.pleito.pleitoId,
                valor: this.valor || null,
                parcela: this.parcela || null,
                mes: this.mes && this.mes.trim() !== '' ? this.$moment(this.mes, 'MM/YYYY').format('YYYY-MM-DD') : null,
                descritivo: this.descritivo || null
            }
            this.$emit('salvar', cronogramaDesembolsoSebraeDto)
            this.fecharModal()
        },
    },
}
</script>
